import { isAiConsentRefusal } from "./refusal";

/**
 * Recognising CMP-01's refusal in the browser.
 *
 * READS A CLONE and answers false for anything that is not the refusal: a 403
 * without the code is an ordinary failure, and a caller must still be able to
 * read its own body.
 *
 * NEVER THROWS. A gateway can answer 403 with an HTML page, and turning a parse
 * problem into a consent refusal would reload the page under a learner who had
 * already consented.
 */
export async function isAiConsentRefusalResponse(res: Response): Promise<boolean> {
  try {
    return isAiConsentRefusal(await res.json());
  } catch {
    return false;
  }
}
